module.exports = __webpack_public_path__ + "img/73.b77b2ed8.jpg";